/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { ImageHelper, RouteHelper, useCanWatchAuthContent } from "@nf/common";
import dynamic from "next/dynamic";

import AppImage from "components/AppImage";
import LinkWithLocale from "components/LinkWithLocale";
import { useSyncCompleted } from "hooks";
import type { IListComponentItemProps } from "../../models";

import styles from "./ListComponentItemPromo.module.scss";

const MediaAdditionalInfo = dynamic(
  () => import("components/Media/MediaAdditionalInfo")
);

const PlayButton = dynamic(() => import("components/PlayButton"));

const MyListButton = dynamic(() => import("components/MyListButton"));

export const ListComponentItemPromo = ({ media }: IListComponentItemProps) => {
  const { canWatch } = useCanWatchAuthContent(media);
  const isAuthProcessCompleted = useSyncCompleted();

  if (!media) {
    return null;
  }

  return (
    <div className={styles.background}>
      <LinkWithLocale href={RouteHelper.goToDetails(media)}>
        <a className={styles.imageLink}>
          <div className={styles.imageContainer}>
            <AppImage
              src={
                ImageHelper.getHighlightAssetFrontpagelUrl(media.Images) || ""
              }
              alt={media.Title || ""}
              className={styles.image}
            />
          </div>
        </a>
      </LinkWithLocale>
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.headerDescr}>{media.Description}</h1>

          <h2 className={styles.title}>{media.Title}</h2>

          <MediaAdditionalInfo
            className={styles.additionalInfo}
            showDuration={false}
            media={media}
          />

          <p className={styles.description}>
            {media?.ShortDescription || media?.LongDescription || ""}
          </p>

          {isAuthProcessCompleted && (
            <div className={styles.buttonsContainer}>
              <PlayButton playBtnStyles={styles.playButton} media={media} />

              {canWatch && <MyListButton showLabel={false} media={media} />}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
